import { Box, Button } from "@mui/material";
import { useState } from "react";
import MaterialTable from "material-table";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import Popup from "../../../Base/views/Popup";
import ReportShcedulerConfigPopUp from "./ReportSchedulerConfigPopUp";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import { DeleteReportScheduleAction } from "../../../../../store/Ancillary/ReportScheduler/Action";

const ReportAutoEmailScheduler = () => {
  const dispatch = useDispatch();
  const { report_schedule_data, isLoading } = useSelector(state => state?.AncillaryReducer?.ReportSchedulerReducer);
  
  const [editedRecord, setEditedRecord] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const handleEdit = (rowData) => {
    setEditedRecord(rowData);
    setOpenPopup(true);
  };
  const handleConfirmDelete = (rowData) => {
    setOpenDialog(true);
    setCurrentData(rowData);
  };
  const handleAdd = () => {
    setEditedRecord();
    setOpenPopup(true);
  };
  const handleDelete = () => {
    setOpenDialog(false);
    dispatch(DeleteReportScheduleAction({ report_scheduling_details_id: currentData?.reports_scheduling_details_id }))
  };
  const addMode = (resetForm) => {
    resetForm();
    setEditedRecord(null);
    setOpenPopup(false);
  };

  const addButton = (
    <Button
      onClick={handleAdd}
      variant="contained"
      className="mpl-primary-btn"
      startIcon={<AddIcon />}
    >
      Add
    </Button>
  );
  return (
    <Box>
      <MaterialTable
        isLoading={isLoading}
        columns={[
          {
            title: "Report",
            field: "reports_list_name",
            cellStyle: { padding: "0px 10px 0px 10px" },
          },
          {
            title: "Email",
            field: "email",
            cellStyle: { padding: "0px 10px 0px 10px" },
          },
          {
            title: "Schedule Type",
            field: "occurence",
            headerStyle: { textAlign: "center"},
            cellStyle: { padding: "0px 10px 0px 10px", textAlign: "center" },
          },
        ]}
        data={report_schedule_data || []}
        options={{
          maxBodyHeight: "54vh",
          minBodyHeight: "54vh",
          rowStyle: { fontSize: "13px" },
          headerStyle: { padding: "0px 10px 0px 10px", fontWeight: "bold" },
          sorting: false,
          search: true,
          searchText: "",
          searchFieldAlignment: "right",
          searchAutoFocus: true,
          searchFieldVariant: "standard",
          filtering: false,
          paging: true,
          pageSizeOptions: [25, 50],
          pageSize: 25,
          paginationType: "stepped",
          showFirstLastPageButtons: false,
          paginationPosition: "bottom",
          exportButton: false,
          exportAllData: true,
          addRowPosition: "first",
          selection: false,
          actionsColumnIndex: -1,
          showSelectAllCheckbox: true,
          showTextRowsSelected: true,
          grouping: false,
          columnsButton: false,
        }}
        actions={[
          (rowData) => ({
            icon: () => <EditIcon />,
            tooltip: "Edit",
            onClick: (_event, rowData) => {
              handleEdit(rowData);
            },
          }),
          (rowData) => ({
            icon: () => <DeleteIcon />,
            tooltip: "Delete",
            onClick: (_event, rowData) => {
              handleConfirmDelete(rowData);
            },
          }),
        ]}
        title={addButton}
      />
      <Popup
        title={editedRecord ? "Edit Report Scheduler" : "Add Report Scheduler"}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        width="600px"
        sx={{
          "& .MuiPaper-root": {
            maxWidth: "600px",
            overflow: "hidden", 
          },
        }}
      >
        <ReportShcedulerConfigPopUp
          editedRecord={editedRecord}
          addMode={addMode}
          setOpenPopup={setOpenPopup}
        />
      </Popup>
      <ConfirmationDialog
        title="Do you wish to proceed?"
        openDialog={openDialog}
        closeDialog={setOpenDialog}
        popupTitle=""
        OkButtonText="Delete"
        onSubmit={handleDelete}
      />
    </Box>
  );
};

export default ReportAutoEmailScheduler;
